export default {
	messages: {
		de: {
			name: 'Name',
		},
		en: {
			name: 'Name',
		},
	},
};
